import { z } from 'zod'

// ============================================
// EXAM ENTITY SCHEMA
// ============================================

export const examSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, 'Exam name is required'),
  code: z.string().min(1, 'Exam code is required'),
  description: z.string().optional(),
  searchName: z.string().optional(), // Lowercase for autocomplete
})

export type Exam = z.infer<typeof examSchema>

// ============================================
// EXAM REFERENCE (denormalized in appointments)
// ============================================

export const examRefSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
})

export type ExamRef = z.infer<typeof examRefSchema>

// ============================================
// CREATE EXAM DTO
// ============================================

export const createExamSchema = z.object({
  name: z.string().min(1, 'Exam name is required'),
  code: z.string().min(1, 'Exam code is required'),
  description: z.string().optional(),
})

export type CreateExam = z.infer<typeof createExamSchema>

// ============================================
// UPDATE EXAM DTO
// ============================================

export const updateExamSchema = createExamSchema.partial()

export type UpdateExam = z.infer<typeof updateExamSchema>

// ============================================
// UTILITY FUNCTION
// ============================================

export function createExamSearchName(name: string, code: string): string {
  return `${name} ${code}`.toLowerCase().trim()
}
